





























































































































import {Component, Prop, Vue} from 'vue-property-decorator'
import {$} from '@/facade'
import {OrbitProject} from '@/model/resource/OrbitProject'
import {getN3InvocationBuilder} from '@/model/wallets/invocationsBuilder'
import {NeoHelper} from '@/helpers/NeoHelper'
import OrbitPersistProjectReviewFormStep from '@/components/orbit/OrbitPersistProjectReviewFormStep.vue'
import OrbitLoadingTransactionStep from '@/components/orbit/OrbitLoadingTransactionStep.vue'
import OrbitSuccessStep from '@/components/orbit/OrbitSuccessStep.vue'
import OrbitInsufficientGasStep from '@/components/orbit/OrbitInsufficientGasStep.vue'
import OrbitUnexpectedErrorStep from '@/components/orbit/OrbitUnexpectedErrorStep.vue'
import OrbitRejectedByTheUserStep from '@/components/orbit/OrbitRejectedByTheUserStep.vue'
import OrbitEditProjectFormStep from '@/components/orbit/OrbitEditProjectFormStep.vue'
import {OrbitEditProjectStep} from '@/enums/OrbitEditProjectStep'
import {PropType} from 'vue'

@Component({
  computed: {
    OrbitEditProjectStep() {
      return OrbitEditProjectStep
    },
  },
  components: {
    OrbitEditProjectFormStep,
    OrbitPersistProjectReviewFormStep,
    OrbitSuccessStep,
    OrbitLoadingTransactionStep,
    OrbitInsufficientGasStep,
    OrbitUnexpectedErrorStep,
    OrbitRejectedByTheUserStep,
  },
})
export default class OrbitEditProjectModal extends Vue {
  @Prop({type: Object as PropType<OrbitProject | null>})
  orbitProject!: OrbitProject | null

  currentStep: OrbitEditProjectStep = OrbitEditProjectStep.FORM
  transactionHash: string | null = null

  async editProject() {
    try {
      if (
        !this.orbitProject ||
        !this.orbitProject.contract ||
        !this.orbitProject.contract.hash ||
        !this.orbitProject.amount ||
        !this.orbitProject.tokenPriced ||
        !this.orbitProject.tokenPriced.hash ||
        !this.orbitProject.instanceId
      ) {
        throw new Error('Missing parameters')
      }

      const n3InvocationBuilder = getN3InvocationBuilder()
      const editOrbitProjectInvocationBuilder = n3InvocationBuilder.editOrbitProjectInvocation(
        {
          projectScriptHash: this.orbitProject.contract.hash,
          assetType: '17',
          amount: String(this.orbitProject.amount),
          tokenScriptHash: this.orbitProject.tokenPriced.hash,
          instanceId: String(this.orbitProject.instanceId),
          eventName: this.orbitProject.eventNames ?? '',
        }
      )

      this.currentStep = OrbitEditProjectStep.WAITING_SIGNATURE

      this.transactionHash = await $.walletAdapter.invokeN3Wallet(
        editOrbitProjectInvocationBuilder
      )

      if (!this.transactionHash) throw new Error('Undefined transaction')

      this.currentStep = OrbitEditProjectStep.VALIDATING_TRANSACTION

      const isTransactionValid = await NeoHelper.validateTransaction(
        this.transactionHash
      )
      if (!isTransactionValid) throw new Error('Failed to verify transaction')

      this.orbitProject.transactionHash = this.transactionHash
      await this.orbitProject.persistOrbitProject()

      this.currentStep = OrbitEditProjectStep.EDITED

      $.toast.success('system.success.persist')
    } catch (error) {
      this.threatError(error)
    }

    this.closeModal()
  }

  onClickCloseModal() {
    if (
      this.currentStep === OrbitEditProjectStep.WAITING_SIGNATURE ||
      this.currentStep === OrbitEditProjectStep.VALIDATING_TRANSACTION
    ) {
      return
    }

    this.closeModal()
  }

  closeModal() {
    this.currentStep = OrbitEditProjectStep.FORM
    this.orbitProject = new OrbitProject()
    this.$emit('close')
  }

  goToReviewFormStep(orbitProject: OrbitProject) {
    this.orbitProject = orbitProject
    this.currentStep = OrbitEditProjectStep.REVIEW_FORM
  }

  private threatError(error: any) {
    console.error(error)

    const isNeonWalletRejected =
      error.message && String(error.message).includes('rejected by the user')

    const isNeoLineWalletRejected =
      error.description &&
      error.description === 'The user cancels, or refuses the dapps request'

    if (isNeonWalletRejected || isNeoLineWalletRejected) {
      this.currentStep = OrbitEditProjectStep.REJECTED_BY_THE_USER
      return
    }

    const hasInsufficientFunds =
      error.message && String(error.message).includes('insufficient funds')
    if (hasInsufficientFunds) {
      this.currentStep = OrbitEditProjectStep.INSUFFICIENT_GAS
      return
    }

    this.currentStep = OrbitEditProjectStep.UNKNOWN_ERROR
  }
}
